import { AnyAction } from "redux";
import {
    VERSIONS_FETCHED_OEM,
    APP_LIST,
    COUNTRIES_FETCHED_OEM,
    SELECTED_COUNTRIES_UPDATED_OEM,
    START_DATE_FETCHED_OEM,
    SELECTED_DATE_RANGE_UPDATED_OEM,
    OEM_COUNTRY_DISTRIBUTION,
    RESET_OEM_ANALYTICS_FILTERS,
    CHART_DATA_FETCHED_OEM,
    RESET_ALL,
    SELECTED_APP_OEM,
    MODELS_FETCHED_OEM,
    SELECTED_MODELS_UPDATED,
    SELECTED_VERSIONS_UPDATED_OEM,
    OEM_APP_STORE_ENGAGEMENT_DATA,
    TOTAL_USERS_FETCHED,
    USER_GROWTH_FETCHED,
    APPS_PER_USER_FETCHED,
} from "../actions/oem_analytics";

const initialState = {
    appsList: [],
    totalInstalls: 0,
    selectedApp: null,
    versions: [],
    selectedVersions: null,
    countries: [],
    models: [],
    selectedCountries: null,
    selectedModels: null,
    startDateForSelectedApp: null,
    selectedDateRange: null,
    selectedPreDefinedDateRange: "Last 30 Days",
    chartSection: { data: [] },
    chartSectionView: null,
    userTrafficSection: {
        totalUsers: null,
        userGrowth: null,
        appsPerUser: null,
        timePerSession: null,
    },
};

interface Version {
    id: string;
    versionName: string;
}

interface AppInstall {
    id: string;
    installs_per_app: number;
    name: string;
}
interface Country {
    id: string;
    name: string;
}

interface Model {
    vehicle_id: string;
    name: string;
}

const formatVersions = (versions: Array<Version>) =>
    versions.map((version) => ({
        id: version.id,
        name: version.versionName,
    }));

const formatAppInstalls = (apps: Array<AppInstall>) =>
    apps.map((app) => ({
        id: app.id,
        installsCount: app.installs_per_app,
        name: app.name,
    }));

const formatCountries = (countries: Array<Country>) =>
    countries.map((country) => ({
        id: country.id,
        name: country.name,
    }));

const formatModels = (models: Array<Model>) =>
    models.map((model) => ({
        id: model.vehicle_id,
        name: model.name,
    }));

const oemAnalyticsReducer = (state = initialState, action: AnyAction) => {
    const { type, payload } = action;

    // eslint-disable-next-line no-extra-boolean-cast
    if (!!state.selectedDateRange) {
        console.log("state in reducer" + JSON.stringify(state.selectedDateRange));
    }

    switch (type) {
        case APP_LIST: {
            const formatedAppInstalls = formatAppInstalls(payload.apps);
            return {
                ...state,
                appsList: formatedAppInstalls,
                totalInstalls: payload.total_app_install_count,
                selectedApp: payload.apps?.length ? formatedAppInstalls[0] : null,
            };
        }
        case VERSIONS_FETCHED_OEM:
            return { ...state, versions: formatVersions(payload.data.data) };
        case SELECTED_VERSIONS_UPDATED_OEM:
            return { ...state, selectedVersions: payload };
        case SELECTED_APP_OEM:
            return { ...state, selectedApp: payload };
        case COUNTRIES_FETCHED_OEM:
            return { ...state, countries: formatCountries(payload.data.data) };
        case MODELS_FETCHED_OEM:
            return { ...state, models: formatModels(payload.data.data) };
        case SELECTED_COUNTRIES_UPDATED_OEM:
            return { ...state, selectedCountries: payload };
        case SELECTED_MODELS_UPDATED:
            return { ...state, selectedModels: payload };
        case START_DATE_FETCHED_OEM:
            return { ...state, startDateForSelectedApp: new Date(payload.data.data.created_at) };
        case SELECTED_DATE_RANGE_UPDATED_OEM:
            return {
                ...state,
                selectedDateRange: payload.newSelectedDateRange,
                selectedPreDefinedDateRange: payload.selectedPreDefinedDateRange,
            };
        case OEM_COUNTRY_DISTRIBUTION:
            return { ...state, oemCountryDistribution: payload.data.data };
        case RESET_OEM_ANALYTICS_FILTERS:
            return {
                ...state,
                versions: initialState.versions,
                selectedVersions: initialState.selectedVersions,
                countries: initialState.countries,
                selectedCountries: initialState.selectedCountries,
                startDateForSelectedApp: initialState.startDateForSelectedApp,
                selectedDateRange: initialState.selectedDateRange,
                selectedPreDefinedDateRange: initialState.selectedPreDefinedDateRange,
            };
        case CHART_DATA_FETCHED_OEM:
            return {
                ...state,
                chartSection: payload.data,
                chartSectionView: payload?.data?.other?.view,
            };
        case RESET_ALL:
            return {
                ...initialState,
            };
        case OEM_APP_STORE_ENGAGEMENT_DATA:
            return { ...state, oemAppStoreEngagementData: payload.data.data };
        case TOTAL_USERS_FETCHED:
            return {
                ...state,
                userTrafficSection: {
                    ...state.userTrafficSection,
                    totalUsers: payload.data.data.count,
                },
            };

        case USER_GROWTH_FETCHED:
            return {
                ...state,
                userTrafficSection: {
                    ...state.userTrafficSection,
                    userGrowth: payload.data.data,
                },
            };

        case APPS_PER_USER_FETCHED:
            return {
                ...state,
                userTrafficSection: {
                    ...state.userTrafficSection,
                    appsPerUser: payload.data.data,
                },
            };
        default:
            return state;
    }
};

export default oemAnalyticsReducer;
